import axios from 'axios'
import { BASE_URL } from '@/config/urls'

export const axiosInstance = axios.create({
  baseURL: BASE_URL
})
